export const selectToast = (state) => state.toast
